import React from 'react'

import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import { Span } from 'components'
import { IListaContratos } from 'pages/Supplier/Users/CollaboratorContract'
import { TYPOGRAPHY, COLORS, FONTS } from 'utils'

import { CardItemStyled } from './CardItem.styles'

interface ICardItem {
  contract: IListaContratos
}

const CardItem: React.FC<ICardItem> = ({ contract }) => {
  return (
    <CardItemStyled>
      {contract.selected ? (
        <CheckBoxIcon color="primary" />
      ) : (
        <CheckBoxOutlineBlankIcon color={'disabled'} />
      )}
      <Span
        text={`${contract.content.cdContrato} ${contract.content.txObjetoContrato} - ${contract.content.nmFornecedor}`}
        fontSize={TYPOGRAPHY.bodySize13}
        color={COLORS.black}
        fontWeight={FONTS.regular}
      />
    </CardItemStyled>
  )
}

export default CardItem
